import {notification} from "antd";

export const copy = (link: string) => navigator.clipboard.writeText(link)

export const handleCopy = (link: string) => {
    // navigator.clipboard.writeText won't work if the site is not running on https
    const textArea = document.createElement("textarea")
    textArea.value = link
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
        document.execCommand('copy')
    } catch (err) {
        console.error('Unable to copy to clipboard', err)
    }
    document.body.removeChild(textArea)
    notification.open({
        message: 'Ссылка скопирована успешно!',
        duration: 3.5,
    })
}
